// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
}
.App {
  margin: 0 !important;
  padding: 0 !important;
  box-sizing: border-box !important;
  text-align: center;
  height: 100%;
}

.App-logo {
  height: 40vmin;
  pointer-events: none;
}

@media (prefers-reduced-motion: no-preference) {
  .App-logo {
    animation: App-logo-spin infinite 20s linear;
  }
}

.App-header {
  background-color: #282c34;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: calc(10px + 2vmin);
  color: white;
}

.App-link {
  color: #61dafb;
}

@keyframes App-logo-spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* #main {
  width: 100%;
  height: 100vh;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url("./images/homee.png");
  z-index: 0;
} */

#main::before {
  position: absolute;
  content: "";
  background: radial-gradient(
    ellipse at center,
    rgba(0, 0, 0, 0.38) 0%,
    rgba(0, 0, 0, 0.6) 100%
  );
  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#61b50808', endColorstr='#99000000', GradientType=1);
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: -1;
}

.header-heading {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
  color: white;
}

.bank-heading {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.header-heading h2 {
  font-size: 2.5rem;
  color: #fff;
  margin: 0;
  padding: 0;
}

.header-heading h1 {
  font-size: 5rem;
  margin: 0.5rem 0;
  color: #fff;
}

.header-heading h1 span {
  color: #0d7cc3;
}

.header-heading .details {
  font-size: 1.2rem;
  color: #fff;
  margin-top: 1rem;
}

.header-btns {
  display: flex;
  margin-top: 40px;
  margin-left: 40%;
}

.header-btn {
  width: 160px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1.4rem;
  background-color: #e68f36;
  box-shadow: 5px 10px 30px rgba(255, 2, 2, 0.336);
  border-radius: 5px;
  color: #ffffff;
}

.navbar-nav .nav-link {
  position: relative;
  display: inline-block;
  padding: 10px 15px;
  color: #333;
  text-decoration: none;
  border-radius: 5px;
  transition: all 0.3s ease;
}

.navbar-nav .nav-link:hover {
  border-radius: 10px; /* Rounded corners on hover */
  border: none; /* Remove border */
}

.navbar-nav .nav-link::before {
  content: "";
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  height: 2px;
  background: #eaa259; /* Underline color */
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.navbar-nav .nav-link:hover::before {
  transform: scaleX(1); /* Underline expands on hover */
}

.navbar_shadow {
  box-shadow: rgba(0, 0, 0, 0.15) 0px 10px 10px;
}

.Card:hover {
  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,
    rgba(0, 0, 0, 0.162) 0px 5px 5px;
}

.card-custom {
  width: 600px;
}

@media (max-width: 600px) {
  .card-custom {
    width: 90%;
  }
}

.error-border {
  border: 1px solid red !important;
}

.blue-border .form-check-input {
  border-color: blue !important;
}

.card-custom.blurred {
  filter: blur(5px);
  pointer-events: none;
}

.card-custom .form-check {
  filter: none;
  pointer-events: auto;
}

.input-wrapper {
  background-color: white;
  width: 50%;
  border-radius: 10px;
  height: 2.5rem;
  padding: 0 15px;
  box-shadow: 0px 0px 8px #ddd;
  display: flex;
  align-items: center;
}

input:focus {
  outline: none;
}

#search-icon {
  color: #0d7cc3;
}

@media (max-width: 768px) {
  .video-cam {
    width: 100%;
  }
}
.button-container {
  display: flex !important;
  justify-content: space-between !important; /* Space out buttons evenly */
  gap: 10px !important; /* Adjust the space between buttons */
}

.custom-tabs .nav-link {
  border-radius: 25px; /* Round the corners of the tabs */
  margin: 0; /* Remove any default margin */
  padding: 10px 20px; /* Adjust padding for better appearance */
  border: 1px solid #dee2e6; /* Border around the tabs */
  transition: background-color 0.3s, color 0.3s; /* Smooth transition */
}

.custom-tabs .nav-link:hover {
  border-radius: 25px; /* Round the corners of the tabs */
  background-color: #f8f9fa; /* Light background color on hover */
}

.custom-tabs .nav-link.active {
  border-radius: 25px; /* Ensure active tab also has rounded corners */
  background-color: #007bff; /* Change background color for active tab */
  color: #fff; /* Change text color for active tab */
  border: 1px solid #007bff; /* Ensure border color matches */
}

.custom-tabs .nav-item {
  margin-right: 10px; /* Space between tabs */
}

.custom-tab-content {
  border-radius: 25px; /* Round corners of tab content */
  padding: 20px; /* Add padding inside the content */
  border: 1px solid #dee2e6; /* Border around the content */
}

.top_end {
  top: 40px;
  right: 60px;
}
.top_start {
  top: 40px;
  left: 60px;
}
.no-wrap {
  white-space: nowrap;
}
.dropdown-menu-start {
  right: 0;
  left: auto;
}
.icons_fontsize {
  font-size: 40px;
  color: #e68f36 !important;
}
.zoomed {
  transform: scale(1.05);
  transition: transform 0.3s ease-in-out;
}

.notification-dropdown .dropdown-toggle::after {
  display: none;
}

.notification-dropdown-content {
  max-height: 250px;
  overflow-y: auto;
}

.navbar .nav-link img {
  border: 2px solid #ffffff;
  padding: 2px;
  object-fit: cover;
  background-color: #f8f9fa;
}
.img-round {
  width: 50px;
  height: 50px;
  object-fit: cover;
  border-radius: 50%;
}
.img-round-profile {
  width: 150px;
  height: 150px;
  object-fit: cover;
  border-radius: 50%;
}

.card-success {
  margin-top: 50px;
  border-radius: 15px;
}
.card-header {
  background-color: #28a745;
  color: white;
  font-weight: bold;
  text-align: center;
}
.card-body {
  text-align: center;
}
.success-icon {
  font-size: 3rem;
  color: #28a745;
}
.btn-custom {
  background-color: #007bff;
  color: white;
  border-radius: 25px;
  padding: 10px 20px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;AACnC;AACA;EACE,oBAAoB;EACpB,qBAAqB;EACrB,iCAAiC;EACjC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE;IACE,4CAA4C;EAC9C;AACF;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;AAEA;;;;;;;;GAQG;;AAEH;EACE,kBAAkB;EAClB,WAAW;EAaX;;;;GAIC;EACD,sHAAsH;EACtH,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;AAClC;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,yBAAyB;EACzB,gDAAgD;EAChD,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,kBAAkB;EAClB,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB,EAAE,6BAA6B;EAClD,YAAY,EAAE,kBAAkB;AAClC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,mBAAmB,EAAE,oBAAoB;EACzC,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA;EACE,oBAAoB,EAAE,+BAA+B;AACvD;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE;oCACkC;AACpC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;IACE,UAAU;EACZ;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4BAA4B;EAC5B,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;EACb;AACF;AACA;EACE,wBAAwB;EACxB,yCAAyC,EAAE,6BAA6B;EACxE,oBAAoB,EAAE,qCAAqC;AAC7D;;AAEA;EACE,mBAAmB,EAAE,kCAAkC;EACvD,SAAS,EAAE,8BAA8B;EACzC,kBAAkB,EAAE,yCAAyC;EAC7D,yBAAyB,EAAE,2BAA2B;EACtD,6CAA6C,EAAE,sBAAsB;AACvE;;AAEA;EACE,mBAAmB,EAAE,kCAAkC;EACvD,yBAAyB,EAAE,oCAAoC;AACjE;;AAEA;EACE,mBAAmB,EAAE,+CAA+C;EACpE,yBAAyB,EAAE,2CAA2C;EACtE,WAAW,EAAE,qCAAqC;EAClD,yBAAyB,EAAE,gCAAgC;AAC7D;;AAEA;EACE,kBAAkB,EAAE,uBAAuB;AAC7C;;AAEA;EACE,mBAAmB,EAAE,iCAAiC;EACtD,aAAa,EAAE,mCAAmC;EAClD,yBAAyB,EAAE,8BAA8B;AAC3D;;AAEA;EACE,SAAS;EACT,WAAW;AACb;AACA;EACE,SAAS;EACT,UAAU;AACZ;AACA;EACE,mBAAmB;AACrB;AACA;EACE,QAAQ;EACR,UAAU;AACZ;AACA;EACE,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,sBAAsB;EACtB,sCAAsC;AACxC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB","sourcesContent":["body {\n  margin: 0 !important;\n  padding: 0 !important;\n  box-sizing: border-box !important;\n}\n.App {\n  margin: 0 !important;\n  padding: 0 !important;\n  box-sizing: border-box !important;\n  text-align: center;\n  height: 100%;\n}\n\n.App-logo {\n  height: 40vmin;\n  pointer-events: none;\n}\n\n@media (prefers-reduced-motion: no-preference) {\n  .App-logo {\n    animation: App-logo-spin infinite 20s linear;\n  }\n}\n\n.App-header {\n  background-color: #282c34;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: calc(10px + 2vmin);\n  color: white;\n}\n\n.App-link {\n  color: #61dafb;\n}\n\n@keyframes App-logo-spin {\n  from {\n    transform: rotate(0deg);\n  }\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* #main {\n  width: 100%;\n  height: 100vh;\n  position: relative;\n  background-repeat: no-repeat;\n  background-size: cover;\n  background-image: url(\"./images/homee.png\");\n  z-index: 0;\n} */\n\n#main::before {\n  position: absolute;\n  content: \"\";\n  background: -moz-radial-gradient(\n    center,\n    ellipse cover,\n    rgba(0, 0, 0, 0.38) 0%,\n    rgba(0, 0, 0, 0.6) 100%\n  );\n  background: -webkit-radial-gradient(\n    center,\n    ellipse cover,\n    rgba(0, 0, 0, 0.38) 0%,\n    rgba(0, 0, 0, 0.6) 100%\n  );\n  background: radial-gradient(\n    ellipse at center,\n    rgba(0, 0, 0, 0.38) 0%,\n    rgba(0, 0, 0, 0.6) 100%\n  );\n  filter: progid:DXImageTransform.Microsoft.gradient(startColorstr='#61b50808', endColorstr='#99000000', GradientType=1);\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: -1;\n}\n\n.header-heading {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  text-align: center;\n  color: white;\n}\n\n.bank-heading {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n\n.header-heading h2 {\n  font-size: 2.5rem;\n  color: #fff;\n  margin: 0;\n  padding: 0;\n}\n\n.header-heading h1 {\n  font-size: 5rem;\n  margin: 0.5rem 0;\n  color: #fff;\n}\n\n.header-heading h1 span {\n  color: #0d7cc3;\n}\n\n.header-heading .details {\n  font-size: 1.2rem;\n  color: #fff;\n  margin-top: 1rem;\n}\n\n.header-btns {\n  display: flex;\n  margin-top: 40px;\n  margin-left: 40%;\n}\n\n.header-btn {\n  width: 160px;\n  height: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 1.4rem;\n  background-color: #e68f36;\n  box-shadow: 5px 10px 30px rgba(255, 2, 2, 0.336);\n  border-radius: 5px;\n  color: #ffffff;\n}\n\n.navbar-nav .nav-link {\n  position: relative;\n  display: inline-block;\n  padding: 10px 15px;\n  color: #333;\n  text-decoration: none;\n  border-radius: 5px;\n  transition: all 0.3s ease;\n}\n\n.navbar-nav .nav-link:hover {\n  border-radius: 10px; /* Rounded corners on hover */\n  border: none; /* Remove border */\n}\n\n.navbar-nav .nav-link::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  height: 2px;\n  background: #eaa259; /* Underline color */\n  transform: scaleX(0);\n  transition: transform 0.3s ease;\n}\n\n.navbar-nav .nav-link:hover::before {\n  transform: scaleX(1); /* Underline expands on hover */\n}\n\n.navbar_shadow {\n  box-shadow: rgba(0, 0, 0, 0.15) 0px 10px 10px;\n}\n\n.Card:hover {\n  box-shadow: rgba(0, 0, 0, 0.19) 0px 10px 20px,\n    rgba(0, 0, 0, 0.162) 0px 5px 5px;\n}\n\n.card-custom {\n  width: 600px;\n}\n\n@media (max-width: 600px) {\n  .card-custom {\n    width: 90%;\n  }\n}\n\n.error-border {\n  border: 1px solid red !important;\n}\n\n.blue-border .form-check-input {\n  border-color: blue !important;\n}\n\n.card-custom.blurred {\n  filter: blur(5px);\n  pointer-events: none;\n}\n\n.card-custom .form-check {\n  filter: none;\n  pointer-events: auto;\n}\n\n.input-wrapper {\n  background-color: white;\n  width: 50%;\n  border-radius: 10px;\n  height: 2.5rem;\n  padding: 0 15px;\n  box-shadow: 0px 0px 8px #ddd;\n  display: flex;\n  align-items: center;\n}\n\ninput:focus {\n  outline: none;\n}\n\n#search-icon {\n  color: #0d7cc3;\n}\n\n@media (max-width: 768px) {\n  .video-cam {\n    width: 100%;\n  }\n}\n.button-container {\n  display: flex !important;\n  justify-content: space-between !important; /* Space out buttons evenly */\n  gap: 10px !important; /* Adjust the space between buttons */\n}\n\n.custom-tabs .nav-link {\n  border-radius: 25px; /* Round the corners of the tabs */\n  margin: 0; /* Remove any default margin */\n  padding: 10px 20px; /* Adjust padding for better appearance */\n  border: 1px solid #dee2e6; /* Border around the tabs */\n  transition: background-color 0.3s, color 0.3s; /* Smooth transition */\n}\n\n.custom-tabs .nav-link:hover {\n  border-radius: 25px; /* Round the corners of the tabs */\n  background-color: #f8f9fa; /* Light background color on hover */\n}\n\n.custom-tabs .nav-link.active {\n  border-radius: 25px; /* Ensure active tab also has rounded corners */\n  background-color: #007bff; /* Change background color for active tab */\n  color: #fff; /* Change text color for active tab */\n  border: 1px solid #007bff; /* Ensure border color matches */\n}\n\n.custom-tabs .nav-item {\n  margin-right: 10px; /* Space between tabs */\n}\n\n.custom-tab-content {\n  border-radius: 25px; /* Round corners of tab content */\n  padding: 20px; /* Add padding inside the content */\n  border: 1px solid #dee2e6; /* Border around the content */\n}\n\n.top_end {\n  top: 40px;\n  right: 60px;\n}\n.top_start {\n  top: 40px;\n  left: 60px;\n}\n.no-wrap {\n  white-space: nowrap;\n}\n.dropdown-menu-start {\n  right: 0;\n  left: auto;\n}\n.icons_fontsize {\n  font-size: 40px;\n  color: #e68f36 !important;\n}\n.zoomed {\n  transform: scale(1.05);\n  transition: transform 0.3s ease-in-out;\n}\n\n.notification-dropdown .dropdown-toggle::after {\n  display: none;\n}\n\n.notification-dropdown-content {\n  max-height: 250px;\n  overflow-y: auto;\n}\n\n.navbar .nav-link img {\n  border: 2px solid #ffffff;\n  padding: 2px;\n  object-fit: cover;\n  background-color: #f8f9fa;\n}\n.img-round {\n  width: 50px;\n  height: 50px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n.img-round-profile {\n  width: 150px;\n  height: 150px;\n  object-fit: cover;\n  border-radius: 50%;\n}\n\n.card-success {\n  margin-top: 50px;\n  border-radius: 15px;\n}\n.card-header {\n  background-color: #28a745;\n  color: white;\n  font-weight: bold;\n  text-align: center;\n}\n.card-body {\n  text-align: center;\n}\n.success-icon {\n  font-size: 3rem;\n  color: #28a745;\n}\n.btn-custom {\n  background-color: #007bff;\n  color: white;\n  border-radius: 25px;\n  padding: 10px 20px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
